import React from 'react';

import styled from 'styled-components';

import CompaniesCreateButton from './create/CompaniesCreateButton';

const Container = styled.div`
  display: flex;
`;

const CompaniesActions = () => {
  return (
    <Container>
      <CompaniesCreateButton />
    </Container>
  );
};

export default CompaniesActions;
